import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { PROD } from '../../../common/constants';
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import { GET_BIDDING_TRANSACTION } from '../../../common/URLs';
import moment from 'moment';
import { useEffect } from 'react';
import { loaderService } from '../../../common/custom-loader/loader-service';

import { getLocalStorageItem } from '../../../common/localStorageUtils';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import SearchIcon from "@mui/icons-material/Search";
import apiClient from '../../../axios';

function BiddingTransaction () {

    const [biddingTransactionData, setBiddingTransactionData] = useState();
    const [weeklySchedule, setWeeklySchedule] = useState();
    const [lineNo, setLineNo] = useState();
    // const [searchFilter, setSearchFilter] = useState({
    //     "weeklyScheduleNumber": weeklySchedule,
    //     "scheduleLineNumber": lineNo
    // });

    const columns = [
        { field: 'weeklyScheduleNumber', headerName: 'Schedule No', width: 160},
        { field: 'scheduleLineNumber', headerName: 'Schedule Line no', width: 120},
        { field: 'stakeholderUrn', headerName: 'Actual stakeholder URN', width: 170},
        { field: 'actualValue', headerName: 'Actual Value', width: 100},
        { field: 'bidStakeholderUrn', headerName: 'Bidding Stakeholder URN', width: 180},
        { field: 'biddingValue', headerName: 'Bidding Value', width: 100},
        { field: 'biddingDate', headerName: 'Bidding Date', width: 100,
            valueFormatter: params => params?.value != null ?  moment(params?.value).format("DD/MM/YYYY") : " "},
        { field: 'isBiddingApproved', headerName: 'Is Approved', width: 90},
        { field: 'approvedBy', headerName: 'Approved By', width: 100},
        { field: 'approvedDate', headerName: 'Approved Date', width: 110,
             valueFormatter: params => params?.value != null ?  moment(params?.value).format("DD/MM/YYYY") : " "}
    ]

    // const rows = [
    //     { id: 1, scheduleNo: 'URN-DEVTR00153-2022-Jan-01', scheduleLineNo: "009", actualStakeholder: "abs", actual_value: "100", biddingStakeholder: "URN-VINLL00699", bidding_value: "130", biddingDate: "18/03/2023", isApproved: "yes", approvedBy: "abd", approvedDate: "18/03/2023"},
    //     { id: 2, scheduleNo: 'URN-DEVTR00153-2022-Jan-01', scheduleLineNo: "009", actualStakeholder: "zxc", actual_value: "90", biddingStakeholder: "URN-VINLL00699", bidding_value: "110", biddingDate: "18/03/2023", isApproved: "yes", approvedBy: "fgh", approvedDate: "18/03/2023"}
    // ]

    // useEffect(()=> {
    //     getBiddingTransactionData();
    // }, [weeklySchedule, lineNo]);

    useEffect(()=> {
        getBiddingTransactionData();
    }, []);

    const getBiddingTransactionData = () => {
        loaderService.showLoader();
        apiClient
        .post(
            GET_BIDDING_TRANSACTION,
            {
                weeklyScheduleNumber: weeklySchedule,
                scheduleLineNumber: lineNo
                // weeklyScheduleNumber: "URN-DEVTR00153-2023-feb-23",
                // scheduleLineNumber: "005"
            },
            {
                headers: {
                    Authorization: "Bearer " + getLocalStorageItem('id_token'),
                },
            },
            null
        )
        .then((response) => {
            setBiddingTransactionData(response.data.weeklyTransportSchedulePlanDetailsList);
            console.log(response.data.weeklyTransportSchedulePlanDetailsList);
            loaderService.hideLoader();
        })
        .catch(function(error) {
            console.log(error);
            loaderService.hideLoader();
        });
    };

    const onTextValueChange = (e) => {
        if (e.target.name === "weeklyScheduleNumber") {
            setWeeklySchedule(e.target.value);
        } else if (e.target.name === "scheduleLineNumber") {
            setLineNo(e.target.value);
        }
        // console.log(weeklySchedule);
        // console.log(lineNo);
    }
    
    function onSearchClick(e) {

        console.log(lineNo);
        console.log(weeklySchedule);

        loaderService.showLoader();
        apiClient
        .post(
            GET_BIDDING_TRANSACTION,
            {
                weeklyScheduleNumber: weeklySchedule,
                scheduleLineNumber: lineNo
                // weeklyScheduleNumber: "URN-DEVTR00153-2023-feb-23",
                // scheduleLineNumber: "005"
            },
            {
                headers: {
                    Authorization: "Bearer " + getLocalStorageItem('id_token'),
                },
            },
            null
        )
        .then((response) => {
            setBiddingTransactionData(response.data.weeklyTransportSchedulePlanDetailsList);
            console.log(response.data.weeklyTransportSchedulePlanDetailsList);
            loaderService.hideLoader();
        })
        .catch(function(error) {
            console.log(error);
            loaderService.hideLoader();
        });
        
    }

    return (
        <Container fluid>
            <Row>
                <Col xs={12} md={12}>
                    {!PROD && <p style={{textAlign:"center", fontSize:"2vh"}}>PIT46</p>}
                    <div className='headingStylePIT'>Bidding Transaction</div>
                    <br/>
                    <Row>
                    <Col xs={12} md={5} sm={5} style= {{ marginTop: '20px'}}>
                        <label>Weekly Schedule Number: </label>
                        <label><input type="text" name= "weeklyScheduleNumber" onChange={(e) => onTextValueChange(e)}/></label>
                    </Col>
                    <Col xs={12} md={5} sm={5} style= {{ marginTop: '20px'}}>
                        <label>Schedule Line Number: </label>
                        <label><input type="text" name="scheduleLineNumber" onChange={(e) => onTextValueChange(e)}/></label>   
                    </Col>
                    <Col xs={12} md={2} sm={2} style= {{ marginTop: '20px'}}>
                        <button style={{ border: "0.2vh solid #000000", height: "6vh", borderRadius: "1vh", marginRight: "6vw", marginBottom: "2vh" }} onClick={(e) => onSearchClick(e)}><SearchIcon/></button>
                    </Col>
                    </Row>
                    <br/>
                    <Box sx={{ height: 400, width: '100%'}}>
                        {
                            biddingTransactionData &&
                            <DataGrid
                            rows={biddingTransactionData}
                            columns={columns}
                            pageSize={5}
                            rowsPerPageOptions={[5]}/>
                        }
                    </Box>
                </Col>
            </Row>
        </Container>
    )
}
export default BiddingTransaction;